//* hudInfos
import { SpeedHud } from './huds/speed';
import { SpeedLimitHud } from './huds/speedLimit';
import { SteeringHud } from './huds/steering';
import { TrafficLightHud } from './huds/trafficLight';
import { TurnSignalHud } from './huds/turnSignal';
import { useHudStore } from '../../store/sceneStore';

export function HudManager() {
	const {
		speed,
		speed_limit,
		turn_signal,
		steering_angle,
		mode,
		traffic_light,
		mode_indicator,
	} = useHudStore();

	return (
		<div>
			<SpeedHud speed={speed} />
			<TurnSignalHud direction={turn_signal} />
			<SpeedLimitHud speedLimit={speed_limit} />
			<SteeringHud steeringInfo={{ angle: steering_angle, mode: mode }} />
			<TrafficLightHud
				trafficLight={traffic_light}
				modeIndicator={mode_indicator}
			/>
		</div>
	);
}
